import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-jobdetail',
  templateUrl: './jobdetail.page.html',
  styleUrls: ['./jobdetail.page.scss'],
})
export class JobdetailPage implements OnInit {

  constructor(public modalCtrl: ModalController,) { }

  ngOnInit() {
  }
  dismissModal() {
    this.modalCtrl.dismiss({
      'dismissed': true
    });
  }
  save(){
    alert("Save Success");
    this.dismissModal();
  }
}
